import React from 'react'

export default function TestTipsCard() {
  const tips = [
    'Enter 0 as Test No. to automatically assign the next sequential Test No.',
    'Select Group for a group of Tests (e.g. PCM). This will help you send combined SMS and print combined report cards for these groups.',
    'Tests can be conducted for Single or Multiple Institutes / Branches / Batches by choosing the All option. For combined tests, the system generates Branchwise and Overall Rank for each student.',
    'Choose School/College name for tests targeted for students of a particular school/college based on their syllabus.',
    'After saving the test, click on Enter Marks to record and evaluate scores scored by each candidate.',
    'Min. Marks are the passing cut-off marks that the student is expected to score in the test.',
    'Lesson / Topic Name allows up to 50 characters.',
  ]

  return (
    <div className="rounded-3xl border border-primary/20 bg-gradient-to-b from-primary/[0.04] to-surface-container-lowest p-6 shadow-xs sticky top-24">
      <div className="flex items-center gap-3 border-b border-primary/10 pb-4">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <span className="material-symbols-outlined text-lg">lightbulb</span>
        </div>
        <div>
          <h4 className="font-display text-xs font-black uppercase tracking-wider text-primary">
            TIPS &amp; Guidelines
          </h4>
          <p className="text-[11px] text-on-surface-variant font-medium">Standard Test Operations</p>
        </div>
      </div>

      <ul className="mt-4 space-y-3 text-xs text-on-surface-variant leading-relaxed">
        {tips.map((tip, idx) => (
          <li key={idx} className="flex items-start gap-2.5">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-[10px] font-bold text-primary select-none mt-0.5">
              *
            </span>
            <span className="font-medium text-on-surface/90">{tip}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

